import React, { useState } from 'react';
import { validateFunctionalForm } from '../../../utils';
import constant from '../../../constant';

const EventForm = ({ data, onSubmit }) => {
    const [state, setState] = useState({
        channelName: { name: 'channelName', value: data?.CHANNEL_NAME || '', isRequired: true, error: '' },
        description: { name: 'description', value: data?.DESCRIPTION || '', isRequired: false, error: '' }
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: value,
                error: prev[name].isRequired && !value ? 'This field is required' : ''
            }
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {};
            Object.keys(state).forEach(key => {
                model[key] = state[key].value;
            });
            if (data?.ID) model.id = data.ID;
            onSubmit(model);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-md-12 mb-3">
                    <label>Channel Name {state.channelName.isRequired && <span className='text-danger'> *</span>}</label>
                    <input
                        type="text"
                        name={state.channelName.name}
                        value={state.channelName.value}
                        onChange={handleChange}
                        placeholder="Enter channel name"
                        className={`form-control ${state.channelName.error ? 'is-invalid' : ''}`}
                    />
                    {state.channelName.error && <div className="invalid-feedback">{state.channelName.error}</div>}
                </div>

                <div className="col-md-12 mb-3">
                    <label>Description</label>
                    <textarea
                        name={state.description.name}
                        value={state.description.value}
                        onChange={handleChange}
                        className="form-control"
                        rows="2"
                        placeholder="Enter Description"
                    />
                </div>


            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Save</button>
                <a className="btn btn-danger text-white" href={constant.Authedcomponent.listCategoryEventMasterData.url}>Cancel</a>

            </div>
        </form>
    );
};

export default EventForm;
